'use strict';

var d3 = require('d3');
var $ = require('jquery');
var _ = require('lodash');
var SimpleLineWithTooltip = function SimpleLineWithTooltip(d3Helper, constants, tooltip) {
  /**
   * @param xPropertyName - a property name used to find X value
   * @param yPropertyName - a property name used to find Y value
   * @returns {Function}
   * @constructor
   */
  return function (xPropertyName, yPropertyName, lineInterpolation, tooltipContentProvider) {
    var params, scales, tip, focus;
    var tooltipId = _.uniqueId('simple-line-tooltip-');
    var rootClassName = 'group-simple-line';
    var setClassName = rootClassName + '-' + xPropertyName;
    var tooltipSelector;
    var tooltipInitialized;
    var tooltipAdded = tooltipContentProvider !== undefined;
    if (tooltipAdded) {
      var tooltipClasses = tooltipContentProvider.cssClass ? tooltipContentProvider.cssClass + ' ' + tooltipId : tooltipId;
      tip = tooltip(tooltipContentProvider, tooltipClasses);
      tooltipSelector = '.' + tooltipId;
    }
    var isIsolatedPoint = false;
    var bisectDate = d3.bisector(function (d, xPos) {
      return d - xPos;
    }).left;
    var mouseOverHandler = function mouseOverHandler(d) {
      if (tooltipAdded) {
        var range = scales.xScale.range();
        var x0 = d3.mouse(this)[0];
        var i = bisectDate(range, x0);
        i = i >= d.length ? d.length - 1 : i < 0 ? 0 : i;
        if (!isIsolatedPoint) renderToolTip(d[i]);
      }
    };
    var renderToolTip = function renderToolTip(d0) {
      if (isValidMousePoint(d0)) {
        highlightFocus(d0);
        tip.show(d0, this);
        tip.setPositionNearCursor(tooltipSelector);
      }
    };
    var isValidMousePoint = function isValidMousePoint(d0) {
      return d0[yPropertyName] !== undefined && (d0.visible === undefined || d0.visible !== undefined && d0.visible === true);
    };
    var highlightFocus = function highlightFocus(d0) {
      focus.style('display', null);
      focus.attr('transform', 'translate(' + scales.xScale(d0[xPropertyName]) + ',' + scales.yScale(d0[yPropertyName]) + ')');
    };
    var hideFocus = function hideFocus() {
      focus.style('display', 'none');
    };
    var getIsolatedPoints = function getIsolatedPoints(chartData) {
      var isolatedDataPoints = [];
      var iterateUntil = chartData.length - 1;
      for (var i = 0; i < iterateUntil; i++) {
        // check with next plot
        if (_.isUndefined(chartData[i][yPropertyName]) || _.isUndefined(chartData[i].visible) || false === chartData[i].visible || true === chartData[i].visible && true === chartData[i + 1].visible && !_.isUndefined(chartData[i + 1][yPropertyName])) {
          continue;
        }

        // check with previous plot before considering the current point as isolated point to be plotted
        if (_.isUndefined(chartData[i - 1]) || _.isUndefined(chartData[i - 1].fareToPlot) || _.isUndefined(chartData[i - 1].visible) || false === chartData[i - 1].visible) {
          isolatedDataPoints.push(chartData[i]);
        }
      }

      // check if last plot is an isolated one, if not return without adding it to the array of isolatedDataPoints
      if (_.isUndefined(chartData[iterateUntil].fareToPlot) || true !== chartData[iterateUntil].visible) {
        return isolatedDataPoints;
      }

      // previous if condition will ensure 'visible' is 'defined' and 'true' before reaching this line of code
      if (true === chartData[iterateUntil].visible && !_.isUndefined(chartData[iterateUntil - 1].fareToPlot) && true !== chartData[iterateUntil - 1].visible) {
        isolatedDataPoints.push(chartData[i]);
      }
      return isolatedDataPoints;
    };
    var mouseOutHandler = function mouseOutHandler() {
      if (tooltipAdded) {
        hideFocus();
        tip.hideAndAdjustPosition();
      }
    };

    /**
     * Binds event to group DOM element
     * @param selection
     */
    function bindEvents(selection) {
      if (tooltipAdded) {
        selection.on('mouseout', mouseOutHandler);
        selection.on('mousemove', mouseOverHandler);
        selection.on('mouseover', mouseOverHandler);
      }
    }

    /**
     * Unbinds event from a group DOM element
     * @param selection
     */
    function unbindEvents(selection) {
      selection.on('mouseout', null);
      selection.on('mousemove', null);
      selection.on('mouseover', null);
    }
    var lineFunction = d3.svg.line().defined(function (d) {
      return d[yPropertyName] !== undefined && d.visible !== undefined && d.visible === true;
    }).x(function (d) {
      var rightShift = params === undefined || params.graphAlign === undefined || params.graphAlign.toLowerCase() !== constants.SIMPLE_LINE.ALIGN_LEFT ? scales.xScale.rangeBand() / 2 : 0;
      return scales.xScale(d[xPropertyName]) + rightShift;
    }).y(function (d) {
      return scales.yScale(d[yPropertyName]);
    }).interpolate(lineInterpolation || 'linear');
    var line = function line(container, className) {
      var chartData = container.datum();
      var isolatedPoints = getIsolatedPoints(chartData);
      setClassName = className ? className : setClassName;
      var group = d3Helper.findChildrenByClass(container, setClassName);
      if (!group.empty()) {
        group.remove();
      }
      group = d3Helper.createGroupElement(container, [rootClassName, setClassName].join(' '));
      focus = d3Helper.createGroupElement(group, 'focus');
      focus.style('display', 'none');
      focus.append('circle').attr('r', 5);
      var line = group.selectAll('.simple-line').data([chartData]);
      line.enter().append('path').call(bindEvents).attr('class', 'simple-line');
      line.attr('d', lineFunction).attr({
        'stroke': 'black',
        'stroke-width': '2',
        'fill': 'none'
      });
      line.exit().call(unbindEvents).remove();
      group.append('rect').attr('class', 'overlay').attr('width', params.width).attr('height', params.height).call(bindEvents);
      if (isolatedPoints.length > 0) {
        isIsolatedPoint = true;
        var selectCircle = group.selectAll('.circle').data(isolatedPoints);
        selectCircle.enter().append('circle').attr('class', 'circle').attr('r', 3.5).on('mouseover', function (d) {
          if (xPropertyName && yPropertyName) {
            highlightFocus(d);
            tip.showAndAdjustPosition(d, this);
            tip.setPositionNearCursor(tooltipSelector);
          }
        }).on('mouseout', function () {
          if (tooltipAdded) {
            hideFocus();
            tip.hideAndAdjustPosition();
          }
        }).attr('cx', function (d) {
          return scales.xScale(d[xPropertyName]);
        }).attr('cy', function (d) {
          return scales.yScale(d[yPropertyName]);
        });
      }
      if (!tooltipInitialized && tooltipAdded) {
        line.call(tip);
        tooltipInitialized = true;
      }
    };
    line.params = function (value) {
      params = value;
      return line;
    };
    line.scales = function (value) {
      scales = value;
      return line;
    };
    line.destroy = function () {
      if (tooltipAdded) {
        $(tooltipSelector).remove();
      }
    };
    return line;
  };
};
SimpleLineWithTooltip.$inject = ['d3Helper', 'ChartElementsConstants', 'ChartElementsTooltip'];
module.exports = SimpleLineWithTooltip;